import { StudentSignupForm } from "../../../components/auth/StudentSignupForm";

export default function StudentSignupScreen() {
  return <StudentSignupForm />;
}
